const WATCHLIST_ITEMS_FETCHED = 'WATCHLIST_ITEMS_FETCHED';
const WATCHLIST_ITEM_ADDED = 'WATCHLIST_ITEM_ADDED';
const WATCHLIST_ITEM_REMOVED = 'WATCHLIST_ITEM_REMOVED';
const WATCHLIST_NAVIGATED = 'WATCHLIST_NAVIGATED';

export {
  WATCHLIST_ITEMS_FETCHED,
  WATCHLIST_ITEM_ADDED,
  WATCHLIST_ITEM_REMOVED,
  WATCHLIST_NAVIGATED,
};
